module.exports = __webpack_public_path__ + "static/media/c27.70a18c68.png";